import "../styles/vis.scss"

const scene = document.querySelector(".vis");
var drawScene;
if (scene) {
  const wrapper = scene.querySelector(".vis__wrapper");
  const canvas = scene.querySelector(".vis__canvas");
  const context = canvas.getContext("2d");
  const framesNum = () => scene.querySelectorAll(".vis__frame").length;
  let index = 0;
  let currentX;
  wrapper.onfullscreenchange = () => {
    if (!document.fullscreenElement) {
      wrapper.classList.remove("vis_fullscreen");
    }
  };
  drawScene = () => {
    let img = scene.querySelector(`.vis__frame[data-frame="${index}"]`);
    let sc = scene.querySelector(`.vis__scene[data-frame="${index}"]`);
    // let arrow = scene.querySelector(".vis__arrows");
    if (!img) return;
    context.clearRect(0, 0, canvas.width, canvas.height);
    if (sc) context.drawImage(sc, 0, 0);
    // if (index == 0 && arrow) {
    //   context.drawImage(arrow, 0, 0, canvas.width, canvas.height);
    // }
    context.drawImage(
      img,
      img.dataset.left || 0,
      img.dataset.top || 0,
      img.dataset.width || canvas.width,
      img.dataset.height || canvas.height
    );
  };
  const isFullscreen = () => {
    return wrapper.classList.contains("vis_fullscreen")
  };
  const triggerImagesLoading = () => {
    let el = scene.querySelector('.vis__loading-images');
    el && el.appendChild(document.createElement('div'));
  };
  const enterFullscreen = () => {
    wrapper.classList.add("vis_fullscreen");
    if (typeof wrapper.requestFullscreen != 'undefined') {
      wrapper.requestFullscreen();
    }
    triggerImagesLoading();
  };
  const exitFullscreen = () => {
    wrapper.classList.remove("vis_fullscreen");
    if (typeof document.exitFullscreen != 'undefined' && document.fullscreenElement) {
      document.exitFullscreen()
    }
  };
  const hc = (el, cls) => {
    return el.classList.contains(cls);
  };
  scene.ontouchstart = (e) => {
    if (!isFullscreen()) {
      let firstTouch = e.touches[0];
      let elements = document.elementsFromPoint(firstTouch.clientX, firstTouch.clientY);
      elements = elements.filter(el => hc(el, 'vis__palette') || hc(el, 'vis__button'));
      if (!elements.length) {
        enterFullscreen();
      }
    }
  };
  canvas.ontouchstart = (e) => {
    if (isFullscreen()) {
      let firstTouch = e.touches[0];
      currentX = firstTouch.clientX;
    }
  };
  canvas.ontouchmove = (e) => {
    if (!currentX || !isFullscreen()) return;
    let x = e.touches[0].clientX;
    if (x > currentX + 10) {
      index++;
      if (index >= framesNum()) index = framesNum() - 1;
    } else if (x < currentX - 10) {
      index--;
      if (index < 0) index = 0;
    }
    drawScene();
  }
  canvas.ontouchend = (e) => {
    currentX = undefined;
    scene.dataset.frame = index;
  };
  canvas.onmousedown = (e) => {
    if (isFullscreen()) {
      currentX = e.layerX;
    }
  };
  canvas.onmouseup = () => {
    if (isFullscreen()) {
      currentX = undefined;
      scene.dataset.frame = index;
    } else {
      enterFullscreen(wrapper)
    }
  };
  canvas.onmouseout = () => {
    currentX = undefined;
  }
  canvas.onmousemove = (e) => {
    if (!currentX || !isFullscreen()) return;
    if (currentX && currentX > e.layerX + 30) {
      index--;
      if (index < 0) index = 0;
      currentX = e.layerX;
    } else if (currentX && currentX < e.layerX - 30) {
      index++;
      if (index >= framesNum()) index = framesNum() - 1;
      currentX = e.layerX;
    }
    drawScene();
  }
  // let delays = [500, 1000, 1500, 2000, 3000, 5000, 10000, 15000];
  let delays = Array.from({ length: 20 }, (_, index) => index);
  setTimeout(function func(i) {
    if (typeof delays[i] !== 'undefined') {
      i++;
      setTimeout(drawScene, (delays[i] + 1) * 100, i)
    }
  }, delays[0], 0);
  // setInterval(drawScene, 100)

  document.addEventListener("TwinsparkLoaded", () => {
    window.twinspark.func({
      downloadVis: o => {
        scene.classList.remove("vis_loading");
        let link = document.createElement('a');
        if (o.el.dataset.filename) {
          link.download = o.el.dataset.filename;
        } else {
          link.download = Math.random().toString(36).slice(2);
        }
        link.href = o.el.dataset.href;
        link.click();
      },
      enterFullscreen: o => {
        enterFullscreen(o.el);
      },
      exitFullscreen: () => {
        exitFullscreen();
      },
      toggleSettingItems: (sel, o) => {
        if (!o.el.classList.contains("vis_active")) {
          scene.querySelectorAll(".vis__setting-items").forEach(e => e.classList.remove("vis_open"));
          scene.querySelector(sel).classList.add("vis_open");
          scene.querySelectorAll(".vis__toolbar-button").forEach(e => e.classList.remove("vis_active"));
          o.el.classList.add("vis_active");
        } else {
          scene.querySelector(sel).classList.remove("vis_open");
          o.el.classList.remove("vis_active");
        }
      },
      loading: () => {
        scene.classList.add("vis_loading")
      },
      addFrameParam: o => {
        o.req.opts.data.append("frame", index)
        if (typeof isFullscreen != 'undefined' && isFullscreen()) {
          o.req.opts.data.append('fullscreen', 1)
        }
      },
      // loadImages: () => {
      //   if (isFullscreen()) {
      //     console.log('add loading 0')
      //     scene.classList.add("vis_loading");
      //     triggerImagesLoading();
      //   }
      // },
      waitForImages: o => {
        console.log("add loading")
        scene.classList.add("vis_loading");
        Promise.all(Array.from(o.el.querySelectorAll('img')).filter(img => !img.complete).map(
          img => new Promise(
            resolve => {
              img.onload = img.onerror = resolve;
            }
          ))).then(
            () => {
              console.log('remove loading')
              scene.classList.remove("vis_loading");
              drawScene();
            }
          );
      },
    })
  })
}

document.addEventListener("TwinsparkLoaded", () => {
  window.twinspark.func({
  })
})
